import React from 'react';
import { TagIcon } from 'lucide-react';
interface BrandOffersProps {
  brandSlug: string;
}
export function BrandOffers({
  brandSlug
}: BrandOffersProps) {
  const offers = [{
    id: 1,
    title: 'Buy 2 Get 1 Free',
    description: 'On selected skincare products',
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=700',
    color: 'from-purple-600 to-pink-600'
  }, {
    id: 2,
    title: 'Up to 40% OFF',
    description: 'Summer collection clearance',
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=700',
    color: 'from-orange-600 to-red-600'
  }, {
    id: 3,
    title: 'Free Shipping',
    description: 'On orders over 200 SAR',
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=700',
    color: 'from-green-600 to-teal-600'
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1429" data-mp="3aos7a610qnap">
      <div className="flex items-center gap-3 mb-6" data-id="element-1430" data-mp="3an8ni5g5lu46">
        <div className="bg-[#1E2B55] bg-opacity-10 p-3 rounded-lg" data-id="element-1431" data-mp="3v0kzou5p14id">
          <TagIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-1432" data-mp="3ujtp00l513l" />
        </div>
        <div data-id="element-1433" data-mp="3trwxlv94xbq">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1434" data-mp="3we59npyvgv0">
            Special Offers
          </h2>
          <p className="text-gray-600" data-id="element-1435" data-mp="3qa4j516kt2rs">
            Limited time deals you don't want to miss
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1436" data-mp="3ca3hhjihlrb9">
        {offers.map(offer => <div key={offer.id} className="relative aspect-[14/5] overflow-hidden rounded-lg border border-gray-100 cursor-pointer group" data-id="element-1437" data-mp="3h9pvvwa1xdln">
            <img src={offer.image} alt={offer.title} className="absolute inset-0 h-full w-full object-cover" data-id="element-1438" data-mp="37b0ee4m2hv5x" />
            <div className={`absolute inset-0 bg-gradient-to-r ${offer.color} opacity-80 group-hover:opacity-90 transition-opacity`} data-id="element-1439" data-mp="10llpmseunjxc"></div>
            <div className="absolute inset-0 flex flex-col justify-center p-6 text-white" data-id="element-1440" data-mp="143rl44ovbwnt">
              <h3 className="text-2xl font-bold mb-2" data-id="element-1441" data-mp="z3dmfd95pz2g">{offer.title}</h3>
              <p className="text-white text-opacity-90" data-id="element-1442" data-mp="u4aijw4wxyw2">{offer.description}</p>
            </div>
          </div>)}
      </div>
    </div>;
}